/**
 * iter v28 r300 — Workspace badge: contatore "novità non lette" per immobile.
 *
 * Compagno di `useTabBadges` ma in batch: chiama l'endpoint
 * `/api/dashboard/activity-summary` una sola volta per tutti gli immobili
 * dell'utente, poi confronta con `localStorage.pronto:lastSeen:{pid}` per
 * ogni pid e ritorna `counts[pid] = N` (0 = niente novità).
 */
import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const STORAGE_PREFIX = "pronto:lastSeen:";

function readSeen(pid) {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + pid);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export default function useWorkspaceBadges() {
  const [summary, setSummary] = useState({});

  const fetchSummary = useCallback(async () => {
    try {
      const { data } = await api.get("/dashboard/activity-summary");
      setSummary(data?.summary || {});
    } catch {
      // fail silent
    }
  }, []);

  useEffect(() => {
    fetchSummary();
    // Soft polling lento sul Workspace: 90s. Non è una chat, non urge.
    const t = setInterval(fetchSummary, 90_000);
    const onVis = () => { if (!document.hidden) fetchSummary(); };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [fetchSummary]);

  // Conta per ogni pid quanti tab hanno last_at > seen[tab]
  const counts = {};
  for (const [pid, activity] of Object.entries(summary)) {
    const seen = readSeen(pid);
    let n = 0;
    for (const [tab, lastAt] of Object.entries(activity)) {
      if (!lastAt) continue;
      if (!seen[tab] || seen[tab] < lastAt) n += 1;
    }
    counts[pid] = n;
  }

  return { counts, summary, refetch: fetchSummary };
}
